<template>
  <div>
    <div class="pb-1">
      <span>Formato do arquivo</span>
      <v-icon size="18" class="ml-1" @click="dialog_ativo = true">mdi-help-circle</v-icon>
    </div>

    <v-dialog v-model="dialog_ativo" width="600" content-class="bra-20">
      <v-card>
        <v-card-title class="pt-5 pb-4">
          <span>Formato do arquivo</span>
          <v-spacer />
          <v-btn icon @click="dialog_ativo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <p class="mb-1 font-15 font-weight-medium">O arquivo deve: </p>

          <ul class="ml-n2">
            <li>Ser do formato <span class="font-weight-bold">.xlsx</span></li>
            <li>Possuir 2 colunas: <span class="font-weight-bold">id_filial e id_produto</span></li>
            <li>Possuir o cabeçalho.</li>
            <li>Possuir todos os campos</li>
          </ul>

          <p class="mb-0 mt-4 font-15 font-weight-medium">Exemplo: </p>

          <table class="w-full mt-1 table-com-bordas">
            <thead>
              <tr>
                <th class="text-left">id_filial</th>
                <th class="text-left">id_produto</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="n in 10" :key="n">
                <td class="text-left">{{ `${n}`.padStart(2, '0') }}</td>
                <td class="text-left">{{ `${n}`.padStart(12, '0') }}</td>
              </tr>
            </tbody>
          </table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menu: false,
      dialog_ativo: false
    }
  }
}
</script>

<style scoped>
.table-com-bordas {
  border-collapse: collapse;
  border-spacing: 0;
}
.table-com-bordas tr th, tr td {
  border: 1px solid #cbc8c8;
  padding: 0 3px;
}
</style>
